/* eslint-disable  */
import React, { ReactNode, RefObject, useEffect, useRef } from 'react';

export const useGetter = <T,>(val: T) => {
  const ref = useRef(val);

  ref.current = val;

  return () => ref.current;
};

export const useMouseDownOutside = (
  ref: RefObject<HTMLElement | null>,
  callback: () => void,
) => {
  const handleClick = (e: MouseEvent) => {
    // Document mouse targets are DOM nodes; EventTarget does not expose that.
    if (ref.current && !ref.current.contains(e.target as Node)) {
      callback();
    }
  };
  useEffect(() => {
    document.addEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, []);
};

const StyleChildren = ({ children, ...rest }: { children: ReactNode }) => {
  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child) && (rest as any).className) {
      return React.cloneElement(child, { className: (rest as any).className });
    }
    return child;
  });
  return <>{childrenWithProps}</>;
};
